import { GetServerSideProps } from 'next';
import React from 'react';

import { DefaultPage, RenderBlocks } from '@klappir/container/graphcms';
import { getPage, getUserSuccessArticles } from '@klappir/data/graphcms';
import { DataGraphcms } from '@klappir/types';
import { ArticleCard } from '@klappir/ui/card';
import { Column, Container, Row, SEO } from '@klappir/ui/core';
import styled from '@klappir/vendor/styled';

const ArticleContainer = styled.section`
  margin: 0 auto 64px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(336px, 1fr));
  grid-column-gap: 40px;
  grid-row-gap: 40px;
`;

const Webinars = ({ content, articles }: DataGraphcms.ArticlesPageProps) => {
  if (!content) {
    return <div>Error 404?</div>;
  }
  return (
    <DefaultPage localizations={content.localizations}>
      {content?.seo && (
        <SEO canonical="https://www.klappir.com/articles" {...content.seo} />
      )}
      <RenderBlocks blocks={content?.blocks ?? []} />
      <Container>
        <Row>
          <Column tiny={12} md={12} big={10} huge={10}>
            <ArticleContainer>
              {articles.map((article, i) => (
                <ArticleCard key={i} {...article} />
              ))}
            </ArticleContainer>
          </Column>
        </Row>
      </Container>
    </DefaultPage>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const content = await getPage('webinars', context.locale);
  const articles =
    (await getUserSuccessArticles(context.locale, 'webinar')) || null;
  return {
    props: { content, articles },
  };
};

export default Webinars;
